import { defineComponent as go, watchEffect as ho, computed as r, ref as x, provide as uo, toRef as t, h as i, Transition as Ro } from "vue";
import bo from "./ghl-ui.es987.js";
import { useCheck as vo } from "./ghl-ui.es988.js";
import { useTableData as Co } from "./ghl-ui.es989.js";
import { useScroll as po } from "./ghl-ui.es990.js";
import { useResizable as xo } from "./ghl-ui.es991.js";
import { dataTableProps as Po, dataTableInjectionKey as So } from "./ghl-ui.es992.js";
import { useGroupHeader as wo } from "./ghl-ui.es993.js";
import { useExpand as yo } from "./ghl-ui.es994.js";
import zo from "./ghl-ui.es995.js";
import { generateCsv as To } from "./ghl-ui.es996.js";
import { warnOnce as c } from "./ghl-ui.es899.js";
import Ho from "./ghl-ui.es900.js";
import { useRtl as ko } from "./ghl-ui.es897.js";
import Bo from "./ghl-ui.es901.js";
import Do from "./ghl-ui.es952.js";
import { createId as Eo } from "./ghl-ui.es974.js";
import { createKey as P } from "./ghl-ui.es669.js";
import { useThemeClass as Ko } from "./ghl-ui.es903.js";
import Lo from "./ghl-ui.es323.js";
import { resolveSlot as Fo } from "./ghl-ui.es906.js";
import Mo from "./ghl-ui.es997.js";
import Oo from "./ghl-ui.es938.js";
import { download as $o } from "./ghl-ui.es998.js";
const st = go({
  name: "DataTable",
  alias: ["AdvancedTable"],
  props: Po,
  setup(e, {
    slots: h
  }) {
    process.env.NODE_ENV !== "production" && ho(() => {
      e.onPageChange !== void 0 && c("data-table", "`on-page-change` is deprecated, please use `on-update:page` instead."), e.onPageSizeChange !== void 0 && c("data-table", "`on-page-size-change` is deprecated, please use `on-update:page-size` instead."), e.onSorterChange !== void 0 && c("data-table", "`on-sorter-change` is deprecated, please use `on-update:sorter` instead."), e.onFiltersChange !== void 0 && c("data-table", "`on-filters-change` is deprecated, please use `on-update:filters` instead."), e.onCheckedRowKeysChange !== void 0 && c("data-table", "`on-checked-row-keys-change` is deprecated, please use `on-update:checked-row-keys` instead.");
    });
    const {
      mergedBorderedRef: d,
      mergedClsPrefixRef: l,
      inlineThemeDisabled: f,
      mergedRtlRef: B
    } = Ho(e), D = ko("DataTable", B, l), E = r(() => {
      const {
        bottomBordered: o
      } = e;
      return d.value ? !1 : o !== void 0 ? o : !0;
    }), m = Bo("DataTable", "-data-table", zo, Mo, e, l), S = x(null), u = x(null), {
      getResizableWidth: w,
      clearResizableWidth: K,
      doUpdateResizableWidth: L
    } = xo(), {
      rowsRef: F,
      colsRef: M,
      dataRelatedColsRef: O,
      hasEllipsisRef: $
    } = wo(e, w), I = (o) => {
      const {
        fileName: a = "data.csv",
        keepOriginalData: n = !1
      } = o || {}, v = n ? e.data : z.value, C = To(e.columns, v), p = new Blob([C], {
        type: "text/csv;charset=utf-8"
      }), g = URL.createObjectURL(p);
      $o(g, a.endsWith(".csv") ? a : `${a}.csv`), URL.revokeObjectURL(g);
    }, {
      treeMateRef: R,
      mergedCurrentPageRef: y,
      paginatedDataRef: b,
      rawPaginatedDataRef: z,
      selectionColumnRef: T,
      hoverKeyRef: U,
      mergedPaginationRef: H,
      mergedFilterStateRef: A,
      mergedSortStateRef: N,
      childTriggerColIndexRef: W,
      doUpdatePage: j,
      doUpdateFilters: V,
      onUnstableColumnResize: _,
      deriveNextSorter: X,
      filter: G,
      filters: q,
      clearFilter: J,
      clearFilters: Q,
      clearSorter: Y,
      page: Z,
      sort: ee
    } = Co(e, {
      dataRelatedColsRef: O
    }), {
      doCheckAll: oe,
      doUncheckAll: te,
      doCheck: ae,
      doUncheck: ne,
      headerCheckboxDisabledRef: re,
      someRowsCheckedRef: ie,
      allRowsCheckedRef: de,
      mergedCheckedRowKeySetRef: le,
      mergedInderminateRowKeySetRef: se
    } = vo(e, {
      selectionColumnRef: T,
      treeMateRef: R,
      paginatedDataRef: b
    }), {
      stickyExpandedRowsRef: ce,
      mergedExpandedRowKeysRef: fe,
      renderExpandRef: me,
      expandableRef: ge,
      doUpdateExpandedRowKeys: he
    } = yo(e, R), {
      handleTableBodyScroll: ue,
      handleTableHeaderScroll: Re,
      syncScrollState: be,
      setHeaderScrollLeft: ve,
      leftActiveFixedColKeyRef: Ce,
      leftActiveFixedChildrenColKeysRef: pe,
      rightActiveFixedColKeyRef: xe,
      rightActiveFixedChildrenColKeysRef: Pe,
      leftFixedColumnsRef: Se,
      rightFixedColumnsRef: we,
      fixedColumnLeftMapRef: ye,
      fixedColumnRightMapRef: ze
    } = po(e, {
      bodyWidthRef: S,
      mainTableInstRef: u,
      mergedCurrentPageRef: y
    }), {
      localeRef: Te
    } = Do("DataTable"), He = r(() => e.virtualScroll || e.flexHeight || e.maxHeight !== void 0 || $.value ? "fixed" : e.tableLayout);
    uo(So, {
      props: e,
      treeMateRef: R,
      renderExpandIconRef: t(e, "renderExpandIcon"),
      loadingKeySetRef: x(/* @__PURE__ */ new Set()),
      slots: h,
      indentRef: t(e, "indent"),
      childTriggerColIndexRef: W,
      bodyWidthRef: S,
      componentId: Eo(),
      hoverKeyRef: U,
      mergedClsPrefixRef: l,
      mergedThemeRef: m,
      scrollXRef: r(() => e.scrollX),
      rowsRef: F,
      colsRef: M,
      paginatedDataRef: b,
      leftActiveFixedColKeyRef: Ce,
      leftActiveFixedChildrenColKeysRef: pe,
      rightActiveFixedColKeyRef: xe,
      rightActiveFixedChildrenColKeysRef: Pe,
      leftFixedColumnsRef: Se,
      rightFixedColumnsRef: we,
      fixedColumnLeftMapRef: ye,
      fixedColumnRightMapRef: ze,
      mergedCurrentPageRef: y,
      someRowsCheckedRef: ie,
      allRowsCheckedRef: de,
      mergedSortStateRef: N,
      mergedFilterStateRef: A,
      loadingRef: t(e, "loading"),
      rowClassNameRef: t(e, "rowClassName"),
      mergedCheckedRowKeySetRef: le,
      mergedExpandedRowKeysRef: fe,
      mergedInderminateRowKeySetRef: se,
      localeRef: Te,
      expandableRef: ge,
      stickyExpandedRowsRef: ce,
      rowKeyRef: t(e, "rowKey"),
      renderExpandRef: me,
      summaryRef: t(e, "summary"),
      virtualScrollRef: t(e, "virtualScroll"),
      rowPropsRef: t(e, "rowProps"),
      stripedRef: t(e, "striped"),
      checkOptionsRef: r(() => {
        const {
          value: o
        } = T;
        return o == null ? void 0 : o.options;
      }),
      rawPaginatedDataRef: z,
      filterMenuCssVarsRef: r(() => {
        const {
          self: {
            actionDividerColor: o,
            actionPadding: a,
            actionButtonMargin: n
          }
        } = m.value;
        return {
          "--n-action-padding": a,
          "--n-action-button-margin": n,
          "--n-action-divider-color": o
        };
      }),
      onLoadRef: t(e, "onLoad"),
      mergedTableLayoutRef: He,
      maxHeightRef: t(e, "maxHeight"),
      minHeightRef: t(e, "minHeight"),
      flexHeightRef: t(e, "flexHeight"),
      headerCheckboxDisabledRef: re,
      paginationBehaviorOnFilterRef: t(e, "paginationBehaviorOnFilter"),
      summaryPlacementRef: t(e, "summaryPlacement"),
      scrollbarPropsRef: t(e, "scrollbarProps"),
      syncScrollState: be,
      doUpdatePage: j,
      doUpdateFilters: V,
      getResizableWidth: w,
      onUnstableColumnResize: _,
      clearResizableWidth: K,
      doUpdateResizableWidth: L,
      deriveNextSorter: X,
      doCheck: ae,
      doUncheck: ne,
      doCheckAll: oe,
      doUncheckAll: te,
      doUpdateExpandedRowKeys: he,
      handleTableHeaderScroll: Re,
      handleTableBodyScroll: ue,
      setHeaderScrollLeft: ve,
      renderCell: t(e, "renderCell")
    });
    const ke = {
      filter: G,
      filters: q,
      clearFilters: Q,
      clearSorter: Y,
      page: Z,
      sort: ee,
      clearFilter: J,
      downloadCsv: I,
      scrollTo: (o, a) => {
        var n;
        (n = u.value) === null || n === void 0 || n.scrollTo(o, a);
      }
    }, k = r(() => {
      const {
        size: o
      } = e, {
        common: {
          cubicBezierEaseInOut: a
        },
        self: {
          borderColor: n,
          tdColorHover: v,
          thColor: C,
          thColorHover: p,
          tdColor: g,
          tdTextColor: De,
          thTextColor: Ee,
          thFontWeight: Ke,
          thButtonColorHover: Le,
          thIconColor: Fe,
          thIconColorActive: Me,
          filterSize: Oe,
          borderRadius: $e,
          lineHeight: Ie,
          tdColorModal: Ue,
          thColorModal: Ae,
          borderColorModal: Ne,
          thColorHoverModal: We,
          tdColorHoverModal: je,
          borderColorPopover: Ve,
          thColorPopover: _e,
          tdColorPopover: Xe,
          tdColorHoverPopover: Ge,
          thColorHoverPopover: qe,
          paginationMargin: Je,
          emptyPadding: Qe,
          boxShadowAfter: Ye,
          boxShadowBefore: Ze,
          sorterSize: eo,
          resizableContainerSize: oo,
          resizableSize: to,
          loadingColor: ao,
          loadingSize: no,
          opacityLoading: ro,
          tdColorStriped: io,
          tdColorStripedModal: lo,
          tdColorStripedPopover: so,
          [P("fontSize", o)]: co,
          [P("thPadding", o)]: fo,
          [P("tdPadding", o)]: mo
        }
      } = m.value;
      return {
        "--n-font-size": co,
        "--n-th-padding": fo,
        "--n-td-padding": mo,
        "--n-bezier": a,
        "--n-border-radius": $e,
        "--n-line-height": Ie,
        "--n-border-color": n,
        "--n-border-color-modal": Ne,
        "--n-border-color-popover": Ve,
        "--n-th-color": C,
        "--n-th-color-hover": p,
        "--n-th-color-modal": Ae,
        "--n-th-color-hover-modal": We,
        "--n-th-color-popover": _e,
        "--n-th-color-hover-popover": qe,
        "--n-td-color": g,
        "--n-td-color-hover": v,
        "--n-td-color-modal": Ue,
        "--n-td-color-hover-modal": je,
        "--n-td-color-popover": Xe,
        "--n-td-color-hover-popover": Ge,
        "--n-th-text-color": Ee,
        "--n-td-text-color": De,
        "--n-th-font-weight": Ke,
        "--n-th-button-color-hover": Le,
        "--n-th-icon-color": Fe,
        "--n-th-icon-color-active": Me,
        "--n-filter-size": Oe,
        "--n-pagination-margin": Je,
        "--n-empty-padding": Qe,
        "--n-box-shadow-before": Ze,
        "--n-box-shadow-after": Ye,
        "--n-sorter-size": eo,
        "--n-resizable-container-size": oo,
        "--n-resizable-size": to,
        "--n-loading-size": no,
        "--n-loading-color": ao,
        "--n-opacity-loading": ro,
        "--n-td-color-striped": io,
        "--n-td-color-striped-modal": lo,
        "--n-td-color-striped-popover": so
      };
    }), s = f ? Ko("data-table", r(() => e.size[0]), k, e) : void 0, Be = r(() => {
      if (!e.pagination)
        return !1;
      if (e.paginateSinglePage)
        return !0;
      const o = H.value, {
        pageCount: a
      } = o;
      return a !== void 0 ? a > 1 : o.itemCount && o.pageSize && o.itemCount > o.pageSize;
    });
    return Object.assign({
      mainTableInstRef: u,
      mergedClsPrefix: l,
      rtlEnabled: D,
      mergedTheme: m,
      paginatedData: b,
      mergedBordered: d,
      mergedBottomBordered: E,
      mergedPagination: H,
      mergedShowPagination: Be,
      cssVars: f ? void 0 : k,
      themeClass: s == null ? void 0 : s.themeClass,
      onRender: s == null ? void 0 : s.onRender
    }, ke);
  },
  render() {
    const {
      mergedClsPrefix: e,
      themeClass: h,
      onRender: d,
      $slots: l,
      spinProps: f
    } = this;
    return d == null || d(), i("div", {
      class: [`${e}-data-table`, this.rtlEnabled && `${e}-data-table--rtl`, h, {
        [`${e}-data-table--bordered`]: this.mergedBordered,
        [`${e}-data-table--bottom-bordered`]: this.mergedBottomBordered,
        [`${e}-data-table--single-line`]: this.singleLine,
        [`${e}-data-table--single-column`]: this.singleColumn,
        [`${e}-data-table--loading`]: this.loading,
        [`${e}-data-table--flex-height`]: this.flexHeight
      }],
      style: this.cssVars
    }, i("div", {
      class: `${e}-data-table-wrapper`
    }, i(bo, {
      ref: "mainTableInstRef"
    })), this.mergedShowPagination ? i("div", {
      class: `${e}-data-table__pagination`
    }, i(Lo, Object.assign({
      theme: this.mergedTheme.peers.Pagination,
      themeOverrides: this.mergedTheme.peerOverrides.Pagination,
      disabled: this.loading
    }, this.mergedPagination))) : null, i(Ro, {
      name: "fade-in-scale-up-transition"
    }, {
      default: () => this.loading ? i("div", {
        class: `${e}-data-table-loading-wrapper`
      }, Fo(l.loading, () => [i(Oo, Object.assign({
        clsPrefix: e,
        strokeWidth: 20
      }, f))])) : null
    }));
  }
});
export {
  st as default
};
